<template>
  <div class="container">
    <div class="block">
      <form id="uploadForm" action="submit" enctype="multipart/form-data">
        <input type="file" name="file" />
        <button class="button is-info" @click="submit($event)">Submit</button>
      </form>
      <br />
    </div>
  </div>
</template>

<script>
import request from "@/modules/request";
export default {
  methods: {
    submit(e) {
      e.preventDefault();
      const form = document.querySelector("#uploadForm");

      const formdata = new FormData(form);

      console.log(formdata);

      const opts = {
        method: "POST",
        route: "/api/admin/upload/products",
        data: formdata
      };
      request
        .callInternal(opts)
        .then(results => {
          console.log(results);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
